import React, { useEffect, useState } from 'react'
import { FcCalendar } from 'react-icons/fc'
import { SlLocationPin } from 'react-icons/sl'
import { FaRegUserCircle } from 'react-icons/fa'
import { AiOutlineCalendar } from 'react-icons/ai'
import BRANDLOGO from '../images/bluebus.png';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";

const CheckoutPage = (props) => {
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const [amount, setamount] = useState(0)
    useEffect(() => {
        setamount(props.newBooking.seats.reduce((a, c) => a + c.seatPrice, 0));
        console.log(props.newBooking, props.journeyDetails)

    }, [])


    console.log(props.newBooking)
    const onBtnClicked = async () => {
        const bookingamount = props.newBooking.seats.reduce((a, c) => a + c.seatPrice, 0)
        const response = await axiosPrivate.post('/payment/create-order', { amount: bookingamount }, { credentials: "include" });
        console.log(response.data)
        if (response.data.success) {
            console.log(response.data.order)
            var options = {
                "key": "rzp_test_edIsr96ffIWsWe", // Enter the Key ID generated from the Dashboard
                "amount": bookingamount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                "currency": "INR",
                "name": "BlueBus",
                "description": "Test Transaction",
                "image": BRANDLOGO,
                "order_id": response.data.orderid, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                "handler": async function (response) {
                    const createBookingArray = {
                        busId: props.newBooking.bus_id,
                        boardingPoint: props.newBooking.boardingPoint,
                        droppingPoint: props.newBooking.droppingPoint,
                        seats: props.newBooking.seats,
                        bookedFor: props.journeyDetails.dateofJourney,
                        userId: props.userid,
                        routeId: props.newBooking.routeId,
                        mobileNumber: props.mobile,
                        email: props.email,
                        amount: bookingamount,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_signature: response.razorpay_signature


                    }
                    const responses = await axiosPrivate.post('/booking', createBookingArray, { credentials: "include" });
                    console.log(responses.data)
                    if (responses.data.success) {
                        navigate(`/mybooking/${responses.data.booking._id}`)
                    }


                },

                "notes": {
                    "address": "Razorpay Corporate Office"
                },
                "theme": {
                    "color": "#e7f7fe"
                }
            };
            var rzp1 = new window.Razorpay(options);
            rzp1.open();
            rzp1.on('payment.failed', function (response) {
                alert("PAYMENT FAILED");

            })
        }
    }
    return (
        <div >
            <div className='mx-auto w-[40%] border-2 mt-4 px-4 py-2 pl-2'>
                <div className='flex gap-2 items-center justify-between'>
                    <p className="font-semibold text-lg">{props.newBooking.bus_id}</p>
                    <p>AC Sleeper</p>
                </div>
                <div className='flex items-center justify-between py-2 border-t-2 mt-4 pl-2 '>

                    <div className='flex items-center gap-2'>
                        <AiOutlineCalendar className='w-6 h-6  text-blue-600' />
                        <div>
                            <p className='text-sm text-gray-400'>Departure</p>
                            <p className="mt-1 text-gray-500"> <span>{props.newBooking.boardingPoint.time}</span></p>
                        </div>
                    </div>

                    <div>
                        <p className='text-sm text-gray-400'>Seats</p>
                        <p className="font-semibold text-gray-500">{props.newBooking.seats.map((x) => (<span>{x.seatNumber}  </span>))}</p>
                    </div>

                </div>
                <div className='flex items-center justify-between py-2 border-t-2 mt-4 pl-2'>

                    <div className='flex items-center gap-2'>
                        <SlLocationPin className='w-6 h-6 text-blue-600' />
                        <div>
                            <p className='text-sm text-gray-400'>Boarding Point</p>
                            <p className="mt-1 text-gray-500 font-bold">{props.journeyDetails.originCity}</p>
                            <p className=" text-gray-500"> {props.newBooking.boardingPoint.pointname}</p>
                        </div>
                    </div>

                    <div>
                        <p className='text-sm text-gray-400'>Dropping Point</p>
                        <p className="mt-1 text-gray-500 font-bold">{props.journeyDetails.destinationCity}</p>
                        <p className=" text-gray-500">{props.newBooking.droppingPoint.pointname}</p>
                    </div>

                </div>
                <div className='flex items-center justify-between py-2 border-t-2 mt-4  bg-blue-100 pl-2 pb-3'>

                    <div className='flex items-center gap-2 '>

                        <FaRegUserCircle className='w-6 h-6 text-blue-600' />
                        {props.newBooking.seats.map((x) => (
                            <p className='text-sm '>{x.passengername} ({x.passengerage},{x.passengergender})</p>
                        ))}




                    </div>
                </div>
                <div className='flex items-center justify-between py-2 border-t-2 mt-4   pl-2 pb-3'>


                    <p className='text-lg font-semibold '>Fare:</p>
                    <p className='text-xl font-bold '>₹{amount}</p>
                </div>
                <div className='flex justify-center mb-2'>
                    <button onClick={() => onBtnClicked()} className='bg-blue-400 text-white font-bold text-lg px-5 py-2 rounded-sm'>Proceed to Pay</button>
                </div>

            </div>

        </div >
    )
}

export default CheckoutPage;